/* ===== FREE SHIPPING · INTERRUPTOR GLOBAL =====================
   true  → los productos con el tag NO suman para free shipping
   false → todo el catálogo aplica a free shipping (estado actual)
   Para reactivar: cambia a true y vuelve a etiquetar los productos.
================================================================ */
const FREE_SHIP_EXCLUSIONS_ENABLED = false;

const FREE_SHIP_EXCLUDE_TAG = "EXCLUDE_FROM_FREE_SHIPPING";

const FREE_SHIP_TITLE_DEFAULT = FREE_SHIP_EXCLUSIONS_ENABLED
  ? 'Free U.S. shipping — Country Shirts excluded'
  : 'Free U.S. shipping on all U.S. orders';




if (window.location.href.indexOf("gift-pouch") > -1){
    window.location.replace("https://cristalinaswimwear.com/products/printed-beach-pouches");
};

if (window.location.href.indexOf("gift-necklace") > -1){
    window.location.replace("https://cristalinaswimwear.com");
};


function $cartLoad(){
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload(){
  $('body').addClass('show-cart-preload');
};

function $cartReady(){
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function() {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };

  $('div#rebuy-cart .rebuy-cart__flyout-recommendations').prepend('<div data-rebuy-id="203044"></div>');
  
};


function $renderContainer(){

  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

    '<div class="container-progress-bar">' +

      '<div class="progress-bar__title-wrap">' +
        '<h3 class="progress-bar__title">' + FREE_SHIP_TITLE_DEFAULT + '</h3>' +
      '</div>' +

      '<section class="progress-bar-cart">' +

        // ---- Barra 1: Free Shipping ----
        '<div class="progress-bar-track">' +
          '<div class="progress-bar-track__rail">' +
            '<div id="progress-bar__free-shipping" class="progress-bar-track__fill"></div>' +
          '</div>' +
          '<div class="progress-bar-track__icon">' +
            '<div id="container-icon__free-shipping" class="progress-bar__icon-container">' +
              '<i id="icon__free-shipping" class="fas fa-lock"></i>' +
            '</div>' +
            '<p class="progress-bar__icon-text">Free Shipping</p>' +
          '</div>' +
        '</div>' +

        // ---- Barra 2: Gift with Purchase ----
        '<div class="progress-bar-track">' +
          '<div class="progress-bar-track__rail">' +
            '<div id="progress-bar__pouch" class="progress-bar-track__fill"></div>' +
          '</div>' +
          '<div class="progress-bar-track__icon">' +
            '<div id="container-icon__pouch" class="progress-bar__icon-container">' +
              '<i id="icon__pouch" class="fas fa-lock"></i>' +
            '</div>' +
            '<p class="progress-bar__icon-text">Gift with Purchase!</p>' +
          '</div>' +
        '</div>' +

      '</section>' +

      '<div class="disclaimer-message">' +
        (FREE_SHIP_EXCLUSIONS_ENABLED
          ? '<p>* <a href="/collections/world-cup-country-tees" target="_blank">Country Shirts</a> are excluded from free U.S. shipping.</p>' +
            '<p>** Get a surprise gift on us with your $250+ purchase. While supplies last!</p>'
          : '<p>* Get a surprise gift on us with your $250+ purchase. While supplies last!</p>'
        ) +
      '</div>' +

    '</div>'
  );

};



/* ===== Free Shipping eligibility por tag ===== */

// caché de tags por product_id (evita refetch del mismo producto)
const __FREE_SHIP_TAG_CACHE__ = new Map();

function normalizeFreeShipTag(tag) {
  return String(tag || "").trim().toUpperCase();
}

function getFreeShipHandle(item) {
  if (item && item.handle) return item.handle;
  if (item && item.url && typeof item.url === "string") {
    const match = item.url.match(/\/products\/([^/?]+)/i);
    if (match && match[1]) return match[1];
  }
  return null;
}

// Lee los tags de un item: primero del payload, luego fallback por handle
async function getFreeShipTagsForItem(item) {
  if (!item) return [];

  const pid = item.product_id;

  // 1. Tags directos en el payload de Rebuy
  const tagsRaw = item && item.product && item.product.tags;
  if (tagsRaw) {
    if (Array.isArray(tagsRaw)) {
      return tagsRaw.map(t => String(t).trim()).filter(Boolean);
    }
    if (typeof tagsRaw === "string") {
      return tagsRaw.split(",").map(t => t.trim()).filter(Boolean);
    }
  }

  // 2. Caché
  if (pid && __FREE_SHIP_TAG_CACHE__.has(pid)) {
    return __FREE_SHIP_TAG_CACHE__.get(pid);
  }

  // 3. Fallback: traer el producto por handle
  const handle = getFreeShipHandle(item);
  if (!handle) return [];

  try {
    const res = await fetch(`/products/${handle}.js`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();
    let tags = data && data.tags;
    let arr = [];

    if (Array.isArray(tags)) {
      arr = tags.map(t => String(t).trim()).filter(Boolean);
    } else if (typeof tags === "string") {
      arr = tags.split(",").map(t => t.trim()).filter(Boolean);
    }

    if (pid) __FREE_SHIP_TAG_CACHE__.set(pid, arr);
    return arr;
  } catch (e) {
    console.warn("[Free Ship] No se pudieron leer tags para:", { pid, handle, e });
    return [];
  }
}

// Devuelve true si el item está EXCLUIDO de free shipping
async function isExcludedFromFreeShipping(item) {
  if (!FREE_SHIP_EXCLUSIONS_ENABLED) return false;

  const tags = await getFreeShipTagsForItem(item);
  return tags
    .map(normalizeFreeShipTag)
    .includes(normalizeFreeShipTag(FREE_SHIP_EXCLUDE_TAG));
}

// Calcula el subtotal que SÍ cuenta para free shipping (excluye items con tag)
function lineTotal(item) {
  return typeof item.final_line_price === "number"
    ? item.final_line_price
    : (item.price || 0) * (item.quantity || 1);
}

// Subtotal que cuenta para free shipping
async function getFreeShippingTotal(arrayProducts) {
  if (!arrayProducts || arrayProducts.length === 0) return 0;

  if (!FREE_SHIP_EXCLUSIONS_ENABLED) {
    return arrayProducts.reduce((acc, item) => acc + (item ? lineTotal(item) : 0), 0);
  }

  const flags = await Promise.all(
    arrayProducts.map(i => (i ? isExcludedFromFreeShipping(i) : Promise.resolve(true)))
  );

  return arrayProducts.reduce(
    (acc, item, i) => acc + (flags[i] ? 0 : lineTotal(item)),
    0
  );
}




let __progressBarToken = 0;

async function $progressBar(totalPrice, arrayProducts){

    const token = ++__progressBarToken;

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $free_ship_total = await getFreeShippingTotal($array_products);

    // Si entró una actualización más nueva mientras esperábamos, abortamos
    if (token !== __progressBarToken) return;

    // Barra GWP: progreso hacia los $250 (25000 centavos)
    var $remaining           = Math.max(0, 25000 - $total_price) / 100;
    var $promotion_two       = $remaining.toFixed(2);
    var $porcentPromotionTwo = Math.min(100, ($total_price / 25000) * 100) + "%";

    // ----- Lógica de producto-regalo -----
    function $product_offer(productId){ return productId.product_id === 9659365884151; }
    var $validation_product = $array_products.find($product_offer);

    if ($validation_product !== undefined) {
      if($total_price <= 24999){
        jQuery.post('/cart/update.js', { updates: { 49657151652087: 0 } });
      } else if ($total_price >= 25000){
        let qty_product = $validation_product.quantity;
        let id_variant = $validation_product.id.toString();
        if (qty_product > 1 && (id_variant === '49657151652087')) {
          jQuery.post('/cart/update.js', { updates: { [id_variant]: 1 } });
        }
      }
    }

    // ===================================================================
    //  ESTADOS
    // ===================================================================

    if ($total_price <= 0 && $free_ship_total <= 0){

      $("#progress-bar__free-shipping, #progress-bar__pouch").animate({width: "0%"}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping, #container-icon__pouch").css({"background-color": "white", "border-color": "#ab8c53"});
      $("#icon__free-shipping, #icon__pouch").css("color", "#ab8c53");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">' + FREE_SHIP_TITLE_DEFAULT + '</h3>');

    } else {

      // ---- Barra 1: Free Shipping ----
      if ($free_ship_total > 0){
        $("#progress-bar__free-shipping").animate({width: "100%"}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
        $("#container-icon__free-shipping").css({"background-color": "#ab8c53", "border-color": "#ab8c53"});
        $("#icon__free-shipping").css("color", "#e6dcc9");
      } else {
        // Solo alcanzable con FREE_SHIP_EXCLUSIONS_ENABLED = true
        $("#progress-bar__free-shipping").animate({width: "0%"}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
        $("#container-icon__free-shipping").css({"background-color": "white", "border-color": "#ab8c53"});
        $("#icon__free-shipping").css("color", "#ab8c53");
      }

      // ---- Barra 2: GWP ----
      if ($total_price >= 25000){
        $("#progress-bar__pouch").animate({width: "100%"}, 500);
        $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-check-circle"></i>');
        $("#container-icon__pouch").css({"background-color": "#ab8c53", "border-color": "#ab8c53"});
        $("#icon__pouch").css("color", "#e6dcc9");

        if ($validation_product === undefined){
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { "id": 49657151652087, "quantity": 1 },
            dataType: 'json',
            success: function() {}
          });
        }
      } else {
        $("#progress-bar__pouch").animate({width: $porcentPromotionTwo}, 500);
        $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
        $("#container-icon__pouch").css({"background-color": "white", "border-color": "#ab8c53"});
        $("#icon__pouch").css("color", "#ab8c53");
      }

      // ---- Título dinámico ----
      if ($free_ship_total > 0 && $total_price >= 25000){
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You unlocked free shipping + your gift</h3>');
      } else if ($free_ship_total > 0 && $total_price < 25000){
        $(".progress-bar__title").replaceWith(
          '<div class="progress-bar__title">'+
            '<h3>You unlocked free U.S. shipping</h3>'+
            '<h5>You need <b>$' + $promotion_two + '</b> to get gift</h5>'+
          '</div>'
        );
      } else {
        // Solo alcanzable con FREE_SHIP_EXCLUSIONS_ENABLED = true
        $(".progress-bar__title").replaceWith(
          '<div class="progress-bar__title">'+
            '<h3>Country Shirts don\'t qualify for free shipping</h3>'+
            ($total_price < 25000 ? '<h5>You need <b>$' + $promotion_two + '</b> to get gift</h5>' : '')+
          '</div>'
        );
      }

    }

};



function $renderInsurance(){
  $('.rebuy-cart__flyout-apps').prepend( 
    '<section class="insurance-personalized">' +
        '<div class="insurance-personalized__container">' +
            '<div class="logo">' +
                '<svg version="1.1" id="icon-svg-insure" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 185 200" style="enable-background:new 0 0 185 200;" xml:space="preserve"><g><path d="M92.4,200c-30.7-13.9-86.2-56.3-87.4-88.9L1.8,26.6C1.8,26.6,44.1,0,92.4,0s90.9,26.6,90.9,26.6l-3.4,84.5C178.6,143.7,123.3,186.1,92.4,200z M16.6,34.4l2.9,76.2c1,25.3,49.7,60.9,72.8,73.3V14.4c-19,0-38.2,4.6-55.8,11.2C30,28.3,23,31.2,16.6,34.4z M92.4,190.7c26.3-12.9,78.2-51.4,79.2-79.9l3.2-79.7C151.3,17.5,118.4,8.3,92.4,8.3c-19.7,0-39.7,4.6-58,11.7c-6.8,2.4-17.1,6.6-24.1,11l2.9,79.9C14.4,139.3,66.1,177.8,92.4,190.7z"/></g></svg>' +
            '</div>' +
            '<div class="message">' +
                '<h5>Package Protection</h5>' +
                '<p>Coverage for loss, theft, or transit damage.</p>' +
            '</div>' +
            '<div class="button-price">' +
                '<label class="switch">' +
                    '<input id="insurange-rebuy" type="checkbox">' +
                    '<span class="slider round"></span>' +
                '</label>' +
                '<p class="price">$7.50</p>' +
            '</div>' +
        '</div>' +
    '</section>'
  );
};


function $insurance(totalPrice,arrayProducts){
  
   var $total_price = totalPrice;
   var $array_products = arrayProducts;

    function $findInsurange(id) {
      return id.product_id === 7951559360759;
    };

    var $protectPackage = $array_products.find($findInsurange);

    if($protectPackage === undefined){

      if ($total_price > 750) {

        var currentDate = new Date().toDateString();
        var cookieName = 'insurangeAdd_' + currentDate;
        console.log(cookieName);
      
        if (document.cookie.indexOf(cookieName) === -1) {
          var data = {
            "id": 43932779020535,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
              $('#insurange-rebuy').prop('checked', true);
            }
          });
          
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);
          document.cookie = cookieName + '=1; expires=' + expireDate.toUTCString() + '; path=/';
          
        } else {

          $('#insurange-rebuy').prop('checked', false);
          
        };
        
      } else {

        $('#insurange-rebuy').prop('checked', false);
        
      };


    } else {
      if ($total_price > 750) {

        var $qty_product = $protectPackage.quantity;

        if($qty_product > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              43932779020535: 1
            }
          });
        };
        $('#insurange-rebuy').prop('checked', true);
        
      } else {
        
        $('#insurange-rebuy').prop('checked', false);
        jQuery.post('/cart/update.js', {
          updates: {
            43932779020535: 0
          }
        });
        
      };
      
    };

};


$('.navlink--cart').click(function() {
  $cartLoad();
});



/* ESTRUCTURA HTML DISCOUNT NO RETURNS PRODUCT */

function $renderDiscountReturns(){

  $('.rebuy-cart__flyout').prepend(`
    <div class="loader-active-rebuy-discount">
      <div class="loader-active-rebuy-discount__container">
        <div class="spinner"></div>
        <p>Applying discount...</p>
      </div>      
    </div>
  `);

  
  $('.rebuy-cart__flyout-apps').prepend(` 
    <div id="rebuy-discount-container" class="rebuy-discount-container">

      <div class="rebuy-discount-container__container">

        <div class="rebuy-discount-container__checkbox">
          <label>
            <input type="checkbox" id="rebuyDiscountToggle" />
            <span>I want to get 15% off my entire order — exchange or store credit only</span>
          </label>
        </div>

        <div class="rebuy-discount-container__terms">
          <p>Unlock 15% off your cart when you agree to return for exchange or store credit only. <span id="term-conditions-discount">View terms and conditions</span></p>
        </div>
      
      </div>

    </div>
  `);
};


function $validationDiscountFunction(discountRebuy){

  const checkbox = $('#rebuyDiscountToggle');
  
  if(discountRebuy == '15% OFF – EXCHANGE OR STORE CREDIT ONLY, NO REFUNDS ACCEPTED IN EXCHANGE FOR THIS DISCOUNT'){
    checkbox.off('change');
    checkbox.prop('checked', true);
    $('div#rebuy-cart .rebuy-cart__flyout').addClass('active-discount-returns-exchange');
  } else {
    checkbox.prop('checked', false);
    $('div#rebuy-cart .rebuy-cart__flyout').removeClass('active-discount-returns-exchange');
  }
  
};


function handleDiscountToggleChange() {
  const isChecked = $('#rebuyDiscountToggle').is(':checked');
  const REBUY_DISCOUNT_CODE = '15% OFF – Exchange or store credit only, no refunds accepted in exchange for this discount';
  const Cart = window.Rebuy.Cart;
  const SmartCart = window.Rebuy.SmartCart;

  let loaderDiscount = $('#rebuy-cart .loader-active-rebuy-discount');
  let loaderDiscountMessage = $('#rebuy-cart .loader-active-rebuy-discount p');
  let loaderOriginalMessage = $('#rebuy-cart .loader-active-rebuy-discount p').text();

  loaderDiscount.show();

  if (isChecked) {

    loaderDiscountMessage.text('Applying discount...');

    SmartCart.removeDiscount();
    Cart.removeShopifyDiscount();
    SmartCart.applyDiscount(REBUY_DISCOUNT_CODE);

    setTimeout(() => {
      Cart.fetchShopifyCart(cart => {console.log("cart", cart);});
      setTimeout(() => {
        loaderDiscount.hide();
        loaderDiscountMessage.text(loaderOriginalMessage);
      }, 2000);
    }, 1000);
  
  } else {
    loaderDiscountMessage.text('Removing discount...');
    SmartCart.removeDiscount();
    Cart.removeShopifyDiscount();


    setTimeout(() => {
      Cart.fetchShopifyCart(cart => {console.log("cart", cart);});
      setTimeout(() => {
        loaderDiscount.hide();
        loaderDiscountMessage.text(loaderOriginalMessage);
      }, 2000);
    }, 1000);
  }  
}


$(document).on('change', '#rebuyDiscountToggle', handleDiscountToggleChange);



/* [END] ESTRUCTURA HTML DISCOUNT NO RETURNS PRODUCT */










function removeRebuyDiscount() {
  const Cart = window.Rebuy.Cart;
  const SmartCart = window.Rebuy.SmartCart;

  if (!Cart || !SmartCart) {
    console.warn("Rebuy not ready to remove discount.");
    return;
  }

  const REBUY_DISCOUNT_CODE = '15% OFF – Exchange or store credit only, no refunds accepted in exchange for this discount';

  // Identificar el descuento activo en el SmartCart
  const activeDiscount = window.Rebuy.SmartCart?.discount?.code;

  // Si NO es este descuento, no hacemos nada
  if (activeDiscount !== REBUY_DISCOUNT_CODE) {
    console.log("No specific Rebuy discount to remove.");
    return;
  }

  console.log("Removing special Rebuy discount...");

  // MISMA lógica usada en tu código original
  SmartCart.removeDiscount();
  Cart.removeShopifyDiscount();

  // Refrescar el carrito (igual a tu lógica)
  setTimeout(() => {
    Cart.fetchShopifyCart(cart => {
      console.log("Discount removed → Updated cart:", cart);
    });
  }, 800);
}











document.addEventListener('rebuy:smartcart.ready', async function(event){
  console.log('rebuy:smartcart.ready event', event.detail);
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;
  
  $renderContainer();
  await $progressBar($total_price, $array_products);
  
  
  $renderInsurance();
  $insurance($total_price,$array_products);

  /*
  let discountRebuy = event.detail.smartcart.discount.code;
  console.log(`Descuento rebuy:smartcart.ready: ${discountRebuy}`);
  $renderDiscountReturns();
  $validationDiscountFunction(discountRebuy);
  removeRebuyDiscount();*/
  
  $cartReady();
});



document.addEventListener('rebuy:cart.change', async function(event){

  console.log('rebuy:cart.change event', event.detail);

  var $qty_rebuy = event.detail.cart.cart.item_count;
  if($qty_rebuy > 0){
    $('.cart__icon__content .header__cart__status').css('display','inline-flex');
    $('.cart__icon__content .header__cart__status').text($qty_rebuy);
  } else {
    $('.cart__icon__content .header__cart__status').hide();
    $('.cart__icon__content .header__cart__status').text($qty_rebuy);
  };

  var $container = $('.rebuy-cart__flyout-apps .insurance-personalized');
  var $total_price = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;

  var $container_progress = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  if ($container_progress.length > 0) {
    await $progressBar($total_price, $array_products);
  };

  /*removeRebuyDiscount();*/
   
  if ($container.length > 0) {
    $insurance($total_price,$array_products);
  };  


  // Activa y desactiva descuento 15% OFF de Exchange 👇
  /*
  var $containerDiscount = $('.rebuy-cart__flyout-apps #rebuy-discount-container');
  if ($containerDiscount.length > 0) {
    let discountRebuy = event.detail.cart.discount;
    console.log(`Descuento rebuy:cart.change: ${discountRebuy}`);
    $validationDiscountFunction(discountRebuy);
  };*/ 

  
});



$(document).on('change', '#insurange-rebuy', function() {
  if ($(this).is(':checked')){
     var data = {
      "id": 43932779020535,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log('Add Protect Package');
      }
    });
  } else {
    jQuery.post('/cart/update.js', {
      updates: {
        43932779020535: 0
      }
    });
  };
});
